import React from 'react';
import { BreadcrumbJsonLd } from 'next-seo';
import he from 'he';
import Link from '../Link/Link';

export type BreadcrumbItem = {
  name: string;
  url: string;
};

type Props = {
  items: BreadcrumbItem[];
};

const Breadcrumbs = ({ items }: Props) => {
  if (items.length === 0) return null;
  return (
    <div className="breadcrumb">
      {items
        .map((item, idx) => {
          // Render last element as text
          if (idx === items.length - 1) {
            return (
              <span key={item.url}>{item?.name && he.decode(item?.name)}</span>
            );
          }

          return (
            <Link key={item.url} href={item.url} legacyBehavior>
              <a>{item?.name && he.decode(item?.name)}</a>
            </Link>
          );
        })
        .reduce((result, item, index) => {
          if (index === 0) {
            result.push(item);
            return result;
          }
          return result.concat(
            // eslint-disable-next-line react/no-array-index-key
            <span key={`separator-${index}`}>{` > `}</span>,
            item,
          );
        }, [] as React.ReactElement[])}

      <BreadcrumbJsonLd
        itemListElements={items.map((item, index) => ({
          position: index,
          name: item?.name && he.decode(item?.name),
          item: item.url,
        }))}
      />
    </div>
  );
};

export default React.memo(
  Breadcrumbs,
  (oldProps, newProps) => oldProps.items === newProps.items,
);
